<template>
	<div class="filters-box-row">
		<div class="input-box">
			<span>模板名称：</span>
			<el-input
				v-model="name"
				placeholder="请输入模板名称"
				class="filter-input"
				size="small"
				@keyup.enter.native="search"
			></el-input>
		</div>
		<div class="input-box">
			<span>适用店铺：</span>
			<el-select v-model="shopid" class="filter-input" size='small'>
				<el-option :value="-1" label="全部"></el-option>
				<el-option  v-for="item in shopLists" :value="item.id" :key="item.id" :label="item.name"></el-option>
			</el-select>
		</div>
		<div class="input-btn-box">
			<el-button size="small" type="primary" @click="search">查询</el-button>
			<el-button size="small" type="primary" plain @click="clear">清空</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Search',
	props: {
		shopLists: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			name: '',
			shopid: -1
		}
	},
	methods: {
		search () {
			this.$emit('handleSearch', { name: this.name, shopid: this.shopid })
		},
		clear () {
			this.name = ''
			this.shopid = -1
			this.$emit('handleSearch', { name: this.name, shopid: this.shopid })
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	margin-top :10px;
	height:60px;
	width :100%;
	line-height :60px;
	min-width :600px;
	border-bottom: 1px solid #dce2fd
	padding-bottom 10px
	.input-box {
		display flex
		width: 250px
		margin-left: 20px
		&:nth-of-type(3) {
			margin-right: 50px
		}
		span {
			margin-right: 10px
		}
		.filter-input {
			flex: 1
		}
	}
	.input-btn-box{
		margin-left :20px;
	}
}
</style>
